import moment from 'moment';
import { getInsertReminders } from '@web-schedule/components/CreateBox/util';
import { apiHolder as api, apis } from 'api';
import { store } from '@web-common/state/createStore';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { attachmentDownloadAction } from '@web-common/state/action';
import { getIn18Text } from 'api';
import { buildPtMailContentImgVar } from '@web-edm/AIHosting/MarketingPlan/utils';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const draftApi = api.api.requireLogicalApi(apis.mailDraftApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
export function parsePlainEmailFromErrorRcptString(raw) {
    if (raw == null || typeof raw !== 'string')
        return '';
    const trimmed = raw.trim();
    if (!trimmed)
        return '';
    const lt = trimmed.indexOf('<');
    const gt = trimmed.lastIndexOf('>');
    if (lt !== -1 && gt > lt) {
        return trimmed.slice(lt + 1, gt).trim();
    }
    return trimmed;
}
export const dealTaskMail = async (data) => {
    const { taskMail, entry } = data;
    const { nonEndDate, nonEndTime, enmuReminders, endDate, endTime, expireRemindEveryday: alert } = taskMail;
    let type = nonEndTime ? 2 : 1;
    let alertTime = null;
    let alertAt = null;
    let deadline = 0;
    const personalEmail = data.receiver.filter(item => ['personal', 'external'].includes(item.contactItem.type)).map(item => item.contactItem.contactItemVal);
    const personalToEnterprise = await contactApi.doGetContactByItem({
        type: 'EMAIL',
        filterType: 'enterprise',
        value: personalEmail,
    });
    const personalToEnterpriseMap = {};
    personalToEnterprise.forEach(item => {
        personalToEnterpriseMap[item.contact.accountName] = item;
    });
    const executorList = data.receiver
        .filter(item => item.mailMemberType === 'to')
        .map(item => personalToEnterpriseMap[item.contactItem.contactItemVal] ? personalToEnterpriseMap[item.contactItem.contactItemVal].contact.id : item.contact.contact.id);
    const focusList = data.receiver
        .filter(item => item.mailMemberType === 'cc')
        .map(item => personalToEnterpriseMap[item.contactItem.contactItemVal] ? personalToEnterpriseMap[item.contactItem.contactItemVal].contact.id : item.contact.contact.id);
    if (nonEndDate)
        type = 0;
    if (enmuReminders !== undefined) {
        const getInsertRemindersTime = getInsertReminders(enmuReminders);
        if (getInsertRemindersTime) {
            const { timeUnit, interval, time } = getInsertRemindersTime;
            if (time) {
                const { hr } = time;
                if (interval) {
                    const hor = interval * 24;
                    alertTime = (hor + 24 - time.hr) * 60;
                }
                else {
                    alertAt = hr * 60 * 60;
                }
            }
            else {
                switch (timeUnit) {
                    case 1:
                        alertTime = interval;
                        break;
                    case 2:
                        alertTime = interval * 60;
                        break;
                    case 3:
                        alertTime = 24 * 60;
                        break;
                    default:
                        break;
                }
            }
        }
    }
    if (!nonEndDate) {
        const time = moment(endDate);
        const endDateTime = moment(endTime);
        const hor = endDateTime.hours();
        const min = endDateTime.minutes();
        time.hour(hor).minutes(min).second(59);
        if (nonEndTime) {
            time.second(59).millisecond(0);
            time.hour(23).minutes(59);
        }
        deadline = time.unix();
    }
    data.task = {
        type,
        deadline,
        alert,
        title: entry.title,
        executorList,
        focusList,
    };
    if (alertTime !== null) {
        data.task.alertTime = alertTime;
    }
    if (alertAt !== null) {
        data.task.alertAt = deadline - 24 * 60 * 60 + alertAt;
    }
    return data;
};
export const dealPraiseMail = (data) => {
    var _a, _b, _c, _d, _e, _f;
    const senderContact = (_b = (_a = data === null || data === void 0 ? void 0 : data.sender) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact;
    const praiseLetter = {
        medalId: (_c = data.praiseMail) === null || _c === void 0 ? void 0 : _c.medalId,
        presenter: (_d = data.praiseMail) === null || _d === void 0 ? void 0 : _d.presenter,
        presentationWords: (_e = data.praiseMail) === null || _e === void 0 ? void 0 : _e.presentationWords,
        operator: {
            name: senderContact === null || senderContact === void 0 ? void 0 : senderContact.contactName,
            email: contactApi.doGetModelDisplayEmail(senderContact),
            accountId: senderContact === null || senderContact === void 0 ? void 0 : senderContact.id,
        },
        winners: ((_f = data.praiseMail) === null || _f === void 0 ? void 0 : _f.winners.map(winner => ({
            name: winner.contact.contactName,
            email: contactApi.doGetModelDisplayEmail(winner),
            accountId: winner.contact.id,
        }))) || [],
    };
    data.praiseLetter = praiseLetter;
    delete data.praiseMail;
    return data;
};
export const trackSendMail = ({ receiver, attachments, readRemind, conferenceShow, taskMailShow, puretext, praiseMailShow, scheduledSent, priority, isOneRcpt, requestReadReceipt, }) => {
    const hasCC = receiver.some(item => item.mailMemberType === 'cc');
    const hasBCC = receiver.some(item => item.mailMemberType === 'bcc');
    const hasAttachment = attachments.some(item => { var _a; return !((_a = item.flag) === null || _a === void 0 ? void 0 : _a.usingCloud); });
    const hasCloudAttachment = attachments.some(item => { var _a; return (_a = item.flag) === null || _a === void 0 ? void 0 : _a.usingCloud; });
    trackApi.track('pcMail_click_send_writeMailPage', {
        read_remind: readRemind ? getIn18Text('KAIQIYIDUTI') : getIn18Text('WEIKAIYIDUTI'),
        schedule: conferenceShow ? getIn18Text('YOURICHENG') : getIn18Text('WURICHENG'),
        task: taskMailShow ? getIn18Text('YOURENWU') : getIn18Text('WURENWU'),
        praise: praiseMailShow ? getIn18Text('YOUBIAOYANG') : getIn18Text('WUBIAOYANG'),
        cc: hasCC ? getIn18Text('YOUCHAOSONG') : getIn18Text('WUCHAOSONG'),
        bcc: hasBCC ? getIn18Text('YOUMISONG') : getIn18Text('WUMISONG'),
        timing: scheduledSent ? getIn18Text('DINGSHIFASONG') : getIn18Text('FEIDINGSHIFASONG'),
        priority: priority ? getIn18Text('JINJI') : getIn18Text('FEIJINJI'),
        singleShow: isOneRcpt ? getIn18Text('QUNFADANXIAN') : getIn18Text('FEIQUNFADANXIAN'),
        attachment: hasAttachment ? getIn18Text('YOUPUTONGFUJIAN') : getIn18Text('WUPUTONGFUJIAN'),
        severAttachment: hasCloudAttachment ? getIn18Text('YOUYUNFUJIAN') : getIn18Text('WUYUNFUJIAN'),
        textMode: puretext ? getIn18Text('CHUNWENBENFAXIN') : getIn18Text('FEICHUNWENBENFAXIN'),
        readReceipt: requestReadReceipt ? '开启已读回执' : '未开启已读回执',
    });
};
export const replaceCurrentMailContent = (content, replaceTargets) => {
    const document = new DOMParser().parseFromString(content, 'text/html');
    replaceTargets.forEach(target => {
        const signatureEl = document.querySelectorAll(target);
        if (signatureEl.length > 0) {
            signatureEl.forEach(v => {
                v.parentNode.removeChild(v);
            });
        }
    });
    return document.documentElement.innerHTML;
};
export const resetMailWithDraft = async (cid) => {
    const draftRes = await draftApi.getLatestedDraftByCid(cid);
    console.log('draftResdraftRes', draftRes);
    const { success, data, message: msg } = draftRes;
    if (success && data) {
        const { cid, recoverCid } = data;
        if (recoverCid) {
            console.log('recoverCid', recoverCid);
            cid && draftApi.replaceDraftMailByCid(cid, recoverCid);
            store.dispatch(mailActions.doReplaceMail(data));
            store.dispatch(mailTabActions.doReplaceTabById({
                id: String(cid),
                recoverCid: String(recoverCid),
            }));
            const filterAttachment = (data.entry.attachment || []).filter(item => !item.inlined);
            filterAttachment.forEach(attachment => {
                const temp = Object.assign(Object.assign({}, attachment), { mailId: data.cid, downloadContentId: data.entry.id, downloadId: attachment.fileUrl + data.entry.id, type: 'download', cloudAttachment: attachment.type === 'netfolder' });
                store.dispatch(attachmentDownloadAction(temp, {
                    forward: true,
                    entryId: data.entry.id,
                    cid: data.cid || '0',
                }));
            });
        }
    }
    else {
        try {
            trackApi.track('resetMailWithDraft_error', { reason: msg || '以草稿重生失败' });
            message.error({
                content: getIn18Text('XINJIANYIGUOQI'),
            });
        }
        catch (error) {
            console.error('以草稿重生失败', error);
        }
    }
};
export const accountWork = async (email) => {
    var _a;
    const accounts = await accountApi.getMainAndSubAccounts();
    const mainAccount = (_a = accounts[0]) === null || _a === void 0 ? void 0 : _a.mainAccount;
    if (mainAccount && mainAccount !== email) {
        const accountInfo = accountApi.getSubAccountInfo(email);
        if (!accountInfo) {
            return false;
        }
        if (accountInfo.expired) {
            return false;
        }
        return true;
    }
    else {
        return true;
    }
};
export const edmOperateVarBeforeSend = (content, show = false) => {
    if (!content)
        return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    doc.querySelectorAll('.mce-lx-var').forEach(ele => {
        if (show) {
            let showTxt = ele.getAttribute('data-var-show');
            if ((showTxt === null || showTxt === void 0 ? void 0 : showTxt.startsWith('edmPT')) && process.env.BUILD_ISEDM) {
                const localUrlList = buildPtMailContentImgVar();
                let keyHtml = '';
                switch (showTxt) {
                    case 'edmPTcontentP0':
                        keyHtml = `<img contenteditable='false' style='pointer-events: none;' src='${localUrlList.contentUrlList[0]}' width='840px' />`;
                        break;
                    case 'edmPTcontentP1':
                        keyHtml = `<img contenteditable='false' style='pointer-events: none;' src='${localUrlList.contentUrlList[1]}' width='840px' />`;
                        break;
                    case 'edmPTcontentP2':
                        keyHtml = `<img contenteditable='false' style='pointer-events: none;' src='${localUrlList.contentUrlList[2]}' width='840px' />`;
                        break;
                    case 'edmPTproductUrl':
                        keyHtml = `<img contenteditable='false' style='pointer-events: none;' src='${localUrlList.productPUrl}' width='840px' />`;
                        break;
                    case 'edmPTlastMail':
                        keyHtml = `<img contenteditable='false' style='pointer-events: none;' src='${localUrlList.lastMailUrl}' width='840px' />`;
                        break;
                }
                ele.innerHTML = keyHtml;
                return;
            }
            if (!showTxt && process.env.BUILD_ISEDM) {
                showTxt = edmOperateVarSubjectN(ele.innerHTML, true) || '';
            }
            showTxt && (ele.innerHTML = showTxt);
            return;
        }
        let codeTxt = ele.getAttribute('data-var');
        if (codeTxt && !codeTxt.startsWith('#{')) {
            codeTxt = `#{${codeTxt}}`;
        }
        if (!codeTxt && process.env.BUILD_ISEDM) {
            codeTxt = edmOperateVarSubjectN(ele.innerHTML) || '';
        }
        codeTxt && (ele.innerHTML = codeTxt);
    });
    return doc.documentElement.outerHTML;
};
export const edmOperateVarSubject = (subject, varList, show = false) => {
    if (!subject || !varList)
        return subject;
    if (show) {
        return subject.replace(/\#{([^\}]+)\}/g, (match, p1) => {
            if (varList[p1]) {
                return `[${varList[p1]}]`;
            }
            return match;
        });
    }
    return subject.replace(/\[([^\]]+)\]/g, (match, p1) => {
        if (varList[p1]) {
            return `#{${varList[p1]}}`;
        }
        return match;
    });
};
export const edmDomCodeVarToShow = (dom) => {
    var _a;
    if (!dom)
        return dom;
    const configReducer = store.getState().configReducer;
    const varListAll = getvarList(configReducer.systemVariableList, configReducer.customVariableList);
    const varList = varListAll.codeToShow;
    if (!varList)
        return dom;
    const allVarTextNodes = [];
    let rootNode = dom;
    let node;
    if (typeof rootNode === 'string') {
        const parser = new DOMParser();
        rootNode = parser.parseFromString(rootNode, 'text/html');
    }
    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
            const parentEle = node.parentElement;
            const filterNode = (parentEle === null || parentEle === void 0 ? void 0 : parentEle.closest('.sub_text')) ||
                (parentEle === null || parentEle === void 0 ? void 0 : parentEle.closest('.un_sub_text')) ||
                (parentEle === null || parentEle === void 0 ? void 0 : parentEle.closest('.mail-signature')) ||
                (parentEle === null || parentEle === void 0 ? void 0 : parentEle.closest('.mail-signature-ent')) ||
                ['STYLE', 'TITLE', 'META'].includes(parentEle === null || parentEle === void 0 ? void 0 : parentEle.tagName);
            return filterNode ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
        },
    });
    while ((node = walker.nextNode())) {
        let text = (_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim();
        if (text && /\#{([^\}]+)\}/.test(text)) {
            allVarTextNodes.push(node);
        }
    }
    allVarTextNodes.forEach(node => {
        let text = node.textContent || '';
        const parentEle = node.parentElement;
        text = text.replace(/\#{([^\}]+)\}/g, (match, p1) => {
            if (varList[p1]) {
                return ('<span class="mce-lx-var mceNonEditable varSpan" contenteditable="false"' +
                    'data-var="#{' +
                    p1 +
                    '}" data-var-show="[' +
                    varList[p1] +
                    ']"' +
                    '>[' +
                    varList[p1] +
                    ']</span>');
            }
            return match;
        });
        const newEle = document.createElement('span');
        newEle.innerHTML = text;
        parentEle === null || parentEle === void 0 ? void 0 : parentEle.replaceChild(newEle, node);
    });
    return rootNode;
};
export const edmOperateVarSubjectN = (subject = '', show = false) => {
    if (!subject)
        return subject;
    const configReducer = store.getState().configReducer;
    const varListAll = getvarList(configReducer.systemVariableList, configReducer.customVariableList);
    const varList = show ? varListAll.codeToShow : varListAll.showToCode;
    if (!varList)
        return subject;
    if (show) {
        return subject.replace(/\#{([^\}]+)\}/g, (match, p1) => {
            if (varList[p1]) {
                return `[${varList[p1]}]`;
            }
            return match;
        });
    }
    return subject.replace(/\[([^\]]+)\]/g, (match, p1) => {
        if (varList[p1]) {
            return `#{${varList[p1]}}`;
        }
        return match;
    });
};
export const getvarList = (systemVariableList, customVariableList) => {
    let list1 = [];
    let list2 = [];
    let list3 = [
        { show: '姓名2', code: 'wmt_crm_name_2' },
        { show: '姓名1', code: 'wmt_crm_name_1' },
        { show: '姓名0', code: 'wmt_crm_name_0' },
        { show: '姓名5', code: 'wmt_crm_name_2_1' },
        { show: '姓名4', code: 'wmt_crm_name_1_1' },
        { show: '姓名3', code: 'wmt_crm_name_0_1' },
        { show: '昵称2', code: 'wmt_crm_nickname_2' },
        { show: '昵称1', code: 'wmt_crm_nickname_1' },
        { show: '昵称0', code: 'wmt_crm_nickname' },
        { show: '公司名称0', code: 'wmt_crm_company_0' },
        { show: '公司名称1', code: 'wmt_crm_company_1' },
        { show: '引用最近一次打开的邮件主题', code: 'wmt_recent_open_subject' },
    ];
    if (systemVariableList && systemVariableList.crm) {
        list1 = systemVariableList.crm.other.map(item => ({
            show: item.show,
            code: item.autoScanCode,
        }));
    }
    if (customVariableList) {
        list2 = customVariableList.map(item => ({
            code: item.autoScanVariableName,
            show: item.variableName,
        }));
    }
    const listToObj = {};
    const listToObj2 = {};
    [...list1, ...list2, ...list3].forEach(item => {
        listToObj[item.show] = item.code;
        listToObj2[item.code] = item.show;
    });
    return {
        showToCode: listToObj,
        codeToShow: listToObj2,
    };
};
export const mailContentHasVar = () => {
    var _a;
    const currentMail = store.getState().mailReducer.currentMail;
    const mailContent = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.entry) === null || _a === void 0 ? void 0 : _a.content.content;
    if (mailContent) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(mailContent, 'text/html');
        return doc.querySelectorAll('.mce-lx-var').length > 0;
    }
    return false;
};
export const textHaveVar = (text) => {
    const configReducerState = store.getState().configReducer;
    const { systemVariableList, customVariableList } = configReducerState;
    if (text) {
        let list1 = [];
        let list2 = [];
        let list3 = ['姓名5', '姓名4', '姓名3', '姓名2', '姓名1', '姓名0', '公司名称0', '公司名称1', '昵称2', '昵称1', '昵称0', '引用最近一次打开的邮件主题'];
        if (systemVariableList && systemVariableList.crm) {
            list1 = systemVariableList.crm.other.map(item => item.show);
        }
        if (customVariableList) {
            list2 = customVariableList.map(item => item.variableName);
        }
        list1 = list1.concat(list3);
        let varInText = text.match(/\[([^\]]+)\]/g) || [];
        varInText = varInText.map(item => item.slice(1, -1));
        return {
            systemVar: varInText === null || varInText === void 0 ? void 0 : varInText.some(item => list1.includes(item)),
            customVar: varInText === null || varInText === void 0 ? void 0 : varInText.some(item => list2.includes(item)),
        };
    }
    return { systemVar: false, customVar: false };
};
export const getWaittingSaveMails = () => {
    return window.waittingSaveMails ? window.waittingSaveMails : new Map();
};
export const addWaittingSaveMail = (params) => {
    const { addId, obj } = params;
    if (!window.waittingSaveMails)
        window.waittingSaveMails = new Map();
    window.waittingSaveMails.set(addId, obj);
};
export const updateWaittingSaveMail = (params) => {
    const { updateId, obj } = params;
    if (!window.waittingSaveMails)
        window.waittingSaveMails = new Map();
    window.waittingSaveMails.set(updateId, obj);
};
export const remWaittingSaveMail = (params) => {
    const { remId } = params;
    if (!window.waittingSaveMails)
        return;
    window.waittingSaveMails.delete(remId);
};
export const isDynamicMail = (mail) => {
    var _a;
    if (!mail)
        return false;
    return !!(((_a = mail.status) === null || _a === void 0 ? void 0 : _a.useVariable) || mail.isDyncGroupSend);
};
export const showDynamicMailDraftWarning = () => {
    message.info({ content: '动态邮件暂不支持保存草稿' });
};
export const showDynamicMailTemplateWarning = () => {
    message.info({ content: '动态邮件暂不支持保存为模板' });
};
